import { useEffect, useState } from "react";
import { useArticleStore } from "../store/useArticleStore";
import { loadArticleDraft, saveArticleDraft } from "../utils/draftStorage";

const SAVE_DELAY_MS = 750;

export function useDraftPersistence(): boolean {
  const article = useArticleStore((state) => state.article);
  const restoreArticle = useArticleStore((state) => state.restoreArticle);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let isCanceled = false;
    loadArticleDraft()
      .then((draft) => {
        if (!isCanceled && draft) restoreArticle(draft);
      })
      .catch((error: unknown) => console.debug("Could not restore the local draft:", error))
      .finally(() => {
        if (!isCanceled) setIsReady(true);
      });
    return () => {
      isCanceled = true;
    };
  }, [restoreArticle]);

  useEffect(() => {
    if (!isReady || article.isLoading) return;
    const timeout = window.setTimeout(() => {
      saveArticleDraft(article).catch((error: unknown) =>
        console.debug("Could not save the local draft:", error),
      );
    }, SAVE_DELAY_MS);
    return () => window.clearTimeout(timeout);
  }, [article, isReady]);

  return isReady;
}
